'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';

// -----------------------------------------------------------
//  Radio Buttons
// -----------------------------------------------------------
const RadioButtonGroup = ({ title, options, value, onChange }) => {
  const radioButtonsTitle = title || 'radio-button';

  return (
    <div aria-label={radioButtonsTitle} className="input__radio-button-group" role="radiogroup">
      { title && <h6 className="input__radio-buttons-title">{title}</h6> }
      {options.map(option => {
        const id = `${radioButtonsTitle}-${option.label}`.replace(/\s/g, '-').toLowerCase();

        let attrDisabled = {};
        if(option.disabled) {
          attrDisabled = { disabled: "disabled" }
        }

        return (
          <div key={`option_${option.value}`} className="input__radio-button" >
            <label
              className={classNames({
                checked: option.value == value,
                option_disabled: option.disabled,
              })}
              htmlFor={id}>
              <input
                aria-checked={option.value == value}
                checked={option.value == value}
                id={id}
                name={`option-group__${radioButtonsTitle}`.replace(/\s/g, '-').toLowerCase()}
                type="radio"
                value={option.value}
                {...attrDisabled}
                onChange={({ target }) => onChange(target.value)}
              />
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButtonGroup;
